import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "clase-panel" }
const _hoisted_2 = { class: "clase-tree-container" }
const _hoisted_3 = { style: {"display":"flex","justify-content":"flex-end","gap":"8px","margin-top":"25px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxTreeList = _resolveComponent("DxTreeList")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "clase-header" }, [
      _createElementVNode("i", {
        class: "dx-icon dx-icon-hierarchy",
        style: {"font-size":"18px","margin-right":"8px","opacity":"0.9"}
      }),
      _createElementVNode("span", null, "Clase Articole")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DxTreeList, {
        ref: "treeList",
        "data-source": _ctx.dsClase,
        "key-expr": "ID",
        "parent-id-expr": "ParentID",
        "root-value": null,
        "show-borders": false,
        "column-auto-width": true,
        "word-wrap-enabled": true,
        onSelectionChanged: _ctx.onSelectionChanged,
        "allow-column-reordering": true,
        "column-resizing-mode": "nextColumn",
        "filter-sync-enabled": true,
        "show-row-lines": true,
        "show-column-lines": false,
        "row-alternation-enabled": false,
        "selected-row-keys": _ctx.selectedRowKeys,
        "hover-state-enabled": true,
        onContentReady: _ctx.applyRouteSelection,
        height: "100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DxSelection, {
            mode: "single",
            "auto-expand-all": false,
            "expanded-row-keys": _ctx.expandedRowKeys
          }, null, 8, ["expanded-row-keys"]),
          _createVNode(_component_DxPaging, {
            enabled: true,
            "page-size": 10
          }),
          _createVNode(_component_DxPager, {
            "show-page-size-selector": true,
            "allowed-page-sizes": _ctx.allowedPageSizes,
            "show-info": true
          }, null, 8, ["allowed-page-sizes"]),
          _createVNode(_component_DxSearchPanel, {
            visible: true,
            width: 250
          }),
          _createVNode(_component_DxToolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_DxItem, {
                name: "searchPanel",
                location: "before"
              }),
              _createVNode(_component_DxItem, { location: "after" }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxButton, {
                    icon: "add",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAddClick()))
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxItem, { location: "after" }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxButton, {
                    icon: "refresh",
                    onClick: _ctx.onRefreshClick
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxEditing, {
            allowUpdating: true,
            allowDeleting: true,
            mode: "popup",
            onClick: _ctx.onRowRemoving
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxPopup, {
                closeOnOutsideClick: false,
                showCloseButton: false,
                width: 600,
                height: 410
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxToolbarItem, { template: _ctx.customTitleTemplate }, null, 8, ["template"]),
                  _createVNode(_component_DxToolbarItem, {
                    toolbar: "bottom",
                    widget: "dxButton",
                    location: "after",
                    options: _ctx.successButtonOptions
                  }, null, 8, ["options"]),
                  _createVNode(_component_DxToolbarItem, {
                    toolbar: "bottom",
                    widget: "dxButton",
                    location: "after",
                    options: _ctx.dangerButtonOptions
                  }, null, 8, ["options"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormGrid, { colCount: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxItem, {
                    "col-span": 2,
                    "col-count": 2,
                    "item-type": "group",
                    onFieldDataChanged: _ctx.onFieldDataChanged
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxItem, {
                        "data-field": "Cod",
                        "editor-options": { width: 250, placeholder: 'ex: Tablete' }
                      }),
                      _createVNode(_component_DxItem, {
                        "data-field": "Nume",
                        "editor-options": { width: 250, placeholder: 'ex: Tablete' }
                      }),
                      _createVNode(_component_DxItem, {
                        "data-field": "ParentID",
                        "editor-type": "dxSelectBox",
                        "editor-options": {
              dataSource: _ctx.claseOptions,
              valueExpr: 'ID',
              displayExpr: 'NumeArborescent',
              searchEnabled: true,
              showClearButton: true,
              width: 250,
              placeholder: 'Selectează'
            },
                        label: { text: 'Clasa Părinte' }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxItem, {
                        "data-field": "Nivel",
                        "editor-options": { width: 250, readOnly: true }
                      }),
                      _createVNode(_component_DxItem, {
                        "data-field": "IndexNod",
                        "editor-options": { width: 250, showSpinButtons: true },
                        "editor-type": "dxNumberBox"
                      }),
                      _createVNode(_component_DxItem, {
                        "data-field": "NumeArborescent",
                        "editor-options": { width: 250, readOnly: true }
                      }),
                      _createVNode(_component_DxItem, {
                        "data-field": "WwwID",
                        "editor-options": { width: 250, showSpinButtons: true },
                        "editor-type": "dxNumberBox"
                      }),
                      _createVNode(_component_DxItem, {
                        "data-field": "WwwSyncedDate",
                        "editor-type": "dxDateBox",
                        "editor-options": { width: 250, type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ', useMaskBehavior: true }
                      })
                    ]),
                    _: 1
                  }, 8, ["onFieldDataChanged"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_DxColumn, { "data-field": "Cod" }),
          _createVNode(_component_DxColumn, { "data-field": "Nume" }),
          _createVNode(_component_DxColumn, {
            "data-field": "ID",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Nivel",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "IndexNod",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "NumeArborescent",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ParentID",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "WwwID",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "WwwSyncedDate",
            visible: false
          })
        ]),
        _: 1
      }, 8, ["data-source", "onSelectionChanged", "selected-row-keys", "onContentReady"])
    ]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isModalVisible,
      closeOnOutsideClick: false,
      showCloseButton: false,
      showTitle: true,
      width: 600,
      height: 400
    }, {
      title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("div", { style: {"background":"linear-gradient(90deg, #ff2c21, #ff6a4a)","font-size":"15px","color":"white","font-weight":"bold","padding":"12px 20px"} }, " Adăugare Clasă ", -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_DxForm, {
            formData: _ctx.formData,
            colCount: 2,
            onFieldDataChanged: _ctx.onFieldDataChanged
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxItem, {
                "data-field": "Cod",
                "editor-options": { width: 250, placeholder: 'ex: Tablete' }
              }),
              _createVNode(_component_DxItem, {
                "data-field": "Nume",
                "editor-options": { width: 250, placeholder: 'ex: Tablete' }
              }),
              _createVNode(_component_DxItem, {
                "data-field": "ParentID",
                "editor-type": "dxSelectBox",
                "editor-options": {
            dataSource: _ctx.claseOptions,
            valueExpr: _ctx.getValueExpr,
            displayExpr: _ctx.getDisplayExpr,
            searchEnabled: true,
            showClearButton: true,
            width: 250,
            onValueChanged: _ctx.onParentChanged,
            placeholder: 'Selectează'
          },
                label: { text: 'Clasa Părinte' }
              }, null, 8, ["editor-options"]),
              _createVNode(_component_DxItem, {
                "data-field": "Nivel",
                "editor-options": { width: 250, readOnly: true }
              }),
              _createVNode(_component_DxItem, {
                "data-field": "IndexNod",
                "editor-options": { width: 250, showSpinButtons: true },
                "editor-type": "dxNumberBox"
              }),
              _createVNode(_component_DxItem, {
                "data-field": "NumeArborescent",
                "editor-options": { width: 250, readOnly: true }
              }),
              _createVNode(_component_DxItem, {
                "data-field": "WwwID",
                "editor-options": { width: 250, showSpinButtons: true },
                "editor-type": "dxNumberBox"
              }),
              _createVNode(_component_DxItem, {
                "data-field": "WwwSyncedDate",
                "editor-type": "dxDateBox",
                "editor-options": { width: 250, type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm' }
              })
            ]),
            _: 1
          }, 8, ["formData", "onFieldDataChanged"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DxButton, {
              text: "Salvează",
              type: "success",
              width: "100",
              onClick: _ctx.onSaveAdd
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              text: "Închide",
              type: "danger",
              width: "100",
              onClick: _ctx.onCancel
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}